import Price from '@/presentation/components/elements/Price';
import VaultIcon from '@/presentation/components/elements/VaultIcon';

export const CollectionVault = ({
  name,
  vaultId,
  totalHoldings,
  price,
  onClick,
  type,
}: {
  name?: string;
  vaultId: string;
  totalHoldings?: number;
  price?: bigint;
  onClick: () => void;
  type: 'buy' | 'sell';
}) => {
  return (
    <button
      type="button"
      className="flex items-center w-full px-4 py-2 text-sm hover:bg-gray-200"
      onClick={onClick}
    >
      <VaultIcon
        vaultId={vaultId}
        className="w-8 h-8 flex-none mr-2 rounded-sm"
        alt={name}
      />
      <div className="flex flex-col items-start">
        <h4 className="">{name}</h4>
        <div className="text-gray-500 flex items-center">
          {type === 'sell' ? (
            price != null ? (
              <Price
                value={price}
                maximumSignificantDigits={4}
                minimumSignificantDigits={2}
              />
            ) : (
              '—'
            )
          ) : (
            totalHoldings
          )}
        </div>
      </div>
      <div className="ml-auto text-gray-800">
        {type === 'buy' ? (
          price != null ? (
            <div className="ml-1">
              <Price
                currency="ETH"
                value={price}
                maximumSignificantDigits={4}
                minimumSignificantDigits={2}
              />
              <div className="text-xxs text-right text-gray-500">
                <Price currency="USD" value={price} maximumFractionDigits={0} />
              </div>
            </div>
          ) : (
            '—'
          )
        ) : (
          totalHoldings
        )}
      </div>
    </button>
  );
};

export default CollectionVault;
